import React from "react";
import { FolderIcon } from "@common/folderIcon";

import { Props } from "./types";
import styles from "./styles.scss";

function History({ history, select }: Props) {
  return (
    <div className={styles.history}>
      {history.map((project) => (
        <div
          key={project.uuid}
          className={styles.item}
          onClick={() => select(project)}
        >
          <FolderIcon className={styles.icon} isOpen={false} />
          <p>{project.name}</p>
        </div>
      ))}
    </div>
  );
}

export { History };
